import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n'

import GAuth from 'vue-google-oauth2'
Vue.use(GAuth, {
  clientId: '653918337661-ptko1pj1qpfg654doo6ut4q3tnatelnb.apps.googleusercontent.com',
  scope: 'profile email https://www.googleapis.com/auth/analytics.readonly',
  prompt: 'select_account',
})

Vue.config.productionTip = false

import VueAnalytics from 'vue-analytics'
Vue.use(VueAnalytics, {
  id: 'UA-1244143-17'
})

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
